function checkDevice({
	mobile,
	pc
}) {
	if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
		if (mobile) {
			mobile()
		}
	} else {
		if (pc) {
			pc()
		}
	}
}

// 获得4位数验证码
function getCode() {

	for (let i = 0; i < 10000; i++) {
		let result = ""
		if (i < 10000) {
			// 当前不够4位数的时候
			if (i < 10) {
				result = `000${i}`
			} else
			if (i < 100) {
				result = `00${i}`
			} else
			if (i < 1000) {
				result = `0${i}`
			} else
			if (i < 10000) {
				result = `${i}`
			}
		} else {
			// 当前够了4位数
			break
		}
		console.log("result:", result)
	}
}




export default {
	checkDevice
}



// WEBPACK FOOTER //
// ./src/device.js